import firebase from 'firebase';
import {actionTypes} from 'redux-resource';
import identity from 'lodash/identity';
import {serializeList} from './serializers';

export default (resourceName, listName, modifier = identity) => (
	dispatch => {
		dispatch({
			type: actionTypes.READ_RESOURCES_PENDING,
			resourceName,
			request: listName
		});

		const query = modifier(
			firebase.database().ref(resourceName)
		);

		return query
			.once('value')
			.then(snapshot => {
				const resources = serializeList(snapshot);

				dispatch({
					type: actionTypes.READ_RESOURCES_SUCCEEDED,
					resourceName,
					list: listName,
					request: listName,
					resources
				});

				return resources;
			});
	}
);



// WEBPACK FOOTER //
// ./src/client/redux/actions/helpers/read-list.js